import { render, staticRenderFns } from "./CreateGroupButton.vue?vue&type=template&id=3dcf3c56&scoped=true&"
import script from "./CreateGroupButton.vue?vue&type=script&lang=ts&"
export * from "./CreateGroupButton.vue?vue&type=script&lang=ts&"
import style0 from "./CreateGroupButton.vue?vue&type=style&index=0&id=3dcf3c56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcf3c56",
  null
  
)

export default component.exports